import { render, staticRenderFns } from "./DeadsModal.vue?vue&type=template&id=715a77ad"
import script from "./DeadsModal.vue?vue&type=script&lang=js"
export * from "./DeadsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports